import { render, staticRenderFns } from "./CoursewareEmbedBlock.vue?vue&type=template&id=7976998d&"
import script from "./CoursewareEmbedBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareEmbedBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareEmbedBlock.vue?vue&type=style&index=0&id=7976998d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports